import CryptoJS from 'crypto-js';
import config from '../config';

export const encryptToken = (token) => {
    const encrypted = CryptoJS.AES.encrypt(token, config.REACT_APP_SECRET_KEY).toString();
   return encrypted
  };

  export const decryptToken = (encrypted) => {
    if(encrypted){
    const bytes = CryptoJS.AES.decrypt(encrypted, config.REACT_APP_SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted}
  };